export function formatFrequencyCode(value) {
    switch (value) {
        case "P":
            return "Forever";
        case "M":
            return "Monthly";
        case "A":
            return "Annually";
        default:
            return "Unknown";
    }
}